import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const CpaWaitRegistrationDialog = () => {
    const navigate = useNavigate();
    const t = useTranslation();

    const handleClose = () => {
        navigate(-1);
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Активация')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={3}>
            <Box>
                <Typography variant="body">
                    {t(
                        'Рассмотрим заявку в течение суток. После проверки в меню станет доступен раздел «Монетизация».',
                    )}
                </Typography>
            </Box>

            <Box width="100%">
                <Button
                    variant="filled"
                    size="l"
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                    onClick={handleClose}
                >
                    {t('Хорошо')}
                </Button>
            </Box>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
